import React from "react"

const Header = ({children}) => (
  <header className="site-header">
    {children}
  </header>
)

export default Header